import {styled} from "@mui/material/styles"
import {Grid} from "@mui/material"
import {breakpoints} from "@next/themes"

export const StyledProductGridItem = styled(Grid, {
    shouldForwardProp: prop => prop !== "injectedAd" && !String(prop).startsWith("$"),
})<{
    injectedAd?: boolean
}>`
    padding: 0 0.5rem;
    min-height: var(--prod-sum-tile-min-height-md, 22rem);
    ${props => (props.injectedAd ? `text-align-last:center;` : ``)}
    @media (max-width: ${breakpoints.values.md - 1}px) {
        padding: 0 0.25rem ${props => (props.injectedAd ? `1.5rem` : `0`)} 0.25rem;
        min-height: var(--prod-sum-tile-min-height-sm, 17rem);
    }
`

export default StyledProductGridItem
